import { MessageSquare, X, ArrowLeft, ExternalLink, Plus } from 'lucide-react';
import { Button } from '../ui/button';

const ChatHeader = ({ 
  activeRoom, 
  openRoom, 
  closeChat, 
  setShowNewRoom 
}) => (
  <div className="h-14 border-b flex items-center justify-between px-4 bg-muted/50">
    {activeRoom ? (
      <>
        <button
          onClick={() => openRoom(null)}
          className="p-2 hover:bg-muted rounded-lg transition-colors mr-2"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold truncate">{activeRoom.name}</h3>
          <p className="text-xs text-muted-foreground">
            {activeRoom.participants?.length || 0} participants
          </p>
        </div>
        <button
          onClick={() => window.open(`/chat/${activeRoom.id}`, '_blank')}
          className="p-2 hover:bg-muted rounded-lg transition-colors mr-2"
          title="Open in new tab"
        >
          <ExternalLink className="h-4 w-4" />
        </button>
      </>
    ) : (
      <>
        <div className="flex items-center gap-2">
          <MessageSquare className="h-5 w-5 text-[#ffd108]" />
          <h3 className="font-semibold">Messages</h3>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={() => window.open('/chat', '_blank')}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
            title="Open in new tab"
          >
            <ExternalLink className="h-4 w-4" />
          </button>
          <Button
            size="sm"
            variant="ghost"
            onClick={() => setShowNewRoom(true)}
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </>
    )}
    <button
      onClick={closeChat}
      className="p-2 hover:bg-muted rounded-lg transition-colors"
    >
      <X className="h-5 w-5" />
    </button>
  </div>
);

export default ChatHeader;
